import { hotTopics } from '@/mocks/gossip';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'new') return <i className="ri-sparkling-2-fill text-primary-500"></i>;
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-600"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-accent-600"></i>;
  return <i className="ri-more-line text-foreground-400"></i>;
}

export default function HotBoard() {
  const top3 = hotTopics.slice(0, 3).map((t) => t.rank);
  return (
    <section id="hot" className="scroll-mt-24 py-10 md:py-14 bg-background-100/70">
      <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-8">
        {/* 左侧标题栏 */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium tracking-widest text-foreground-500">TOP TRENDING</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              今日<span className="text-primary-600">吃瓜热榜</span>
            </h2>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              全网讨论热度最高的十个话题，热度每分钟都在变化。戳进去看看大家都在聊什么、吵什么、磕什么。
            </p>
            <a href="#events" className="mt-5 inline-flex items-center gap-1.5 h-10 px-5 rounded-full border border-primary-300 text-primary-700 text-sm font-medium hover:bg-primary-50 transition whitespace-nowrap">
              查看更多盘点 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        {/* 热榜列表 */}
        <div className="lg:col-span-8">
          <div className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
            <ul className="divide-y divide-background-100">
              {hotTopics.map((topic) => (
                <li key={topic.rank}>
                  <a
                    href="#events"
                    className="flex items-center gap-4 px-4 md:px-6 py-3.5 hover:bg-background-50 transition group"
                  >
                    <span
                      className={`font-display text-2xl w-9 text-right leading-none ${
                        top3.includes(topic.rank) ? 'text-primary-500' : 'text-foreground-300'
                      }`}
                    >
                      {String(topic.rank).padStart(2, '0')}
                    </span>
                    <span className="hidden sm:flex w-8 h-8 rounded-full bg-background-100 items-center justify-center text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition">
                      <TrendIcon trend={topic.trend} />
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-700 transition">
                        {topic.title}
                      </span>
                    </span>
                    <span className="text-xs text-foreground-400 shrink-0">{topic.heat}</span>
                    <span className="hidden md:inline-flex px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs shrink-0">{topic.category}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}